export const REFRESH_TOKEN_TIME_GAP_IN_SECONDS = 120;
export const REAUTHENTICATE_INTERVAL = 5 * 60 * 1000;
